export const TOUR_ANCHORS = {
    sidebarNav: 'sidebar-nav',

    hubHero: 'hub-hero',
    hubQuickCapture: 'hub-quick-capture',
    hubInbox: 'hub-inbox',
    hubActivityDigest: 'hub-activity-digest',
    hubThisWeek: 'hub-this-week',
    hubFinances: 'hub-finances',

    groupHubHero: 'group-hub-hero',
    groupMilestones: 'group-milestones',
    groupCapture: 'group-capture',
    groupInbox: 'group-inbox',
    groupWaitingOnYou: 'group-waiting-on-you',
    groupActivityDigest: 'group-activity-digest',
} as const;

export type TourAnchor = (typeof TOUR_ANCHORS)[keyof typeof TOUR_ANCHORS];

export function anchorSelector(anchor: TourAnchor): string {
    return `[data-tour="${anchor}"]`;
}

export function findAnchor(anchor: TourAnchor): HTMLElement | null {
    return document.querySelector<HTMLElement>(anchorSelector(anchor));
}
